import React, { useState, useEffect, useCallback } from "react";
import MainLayout from "../../Layouts/MainLayout";
import SectionHeader from "../molecules/SectionHeader";
import ManagePartnerTemplet from "../molecules/ManagePartnerTable";
import { service } from "../../../services/AxiosServices";
import { toast } from "react-toastify";
import { PartnerCompany, PartnerMember} from '../types/User';


const ManagePartnerCompanys: React.FC = () => {
  const [error, setError] = useState('');
  const [loading, setLoading] = useState<boolean>(false);
  const [companies, setCompanies] = useState<PartnerCompany[]>([]);

  const fetchCompanies = useCallback(async () => {
    setLoading(true);
    try {
      const response = await service<any[]>("/get-all-companies", "post");
      console.log("Raw API Response:", response.data);
      const formattedCompanies: PartnerCompany[] = response.data.map((company: any) => {
        return {
          id: company.company_id,
          company_name: company.company_name,
          created_at: company.created_at,
          updated_at: company.updated_at || undefined,
          deleted_at: company.deleted_at ?? null,
          users: company.members.map((member: any) => ({
            id: member.user_id,
            first_name: member.first_name,
            last_name: member.last_name,
          })),
        };
      });
      formattedCompanies.sort((a, b) => {
        const dateA = new Date(a.created_at).getTime();
        const dateB = new Date(b.created_at).getTime();
        return dateB - dateA; // bigger date first
      });
      setCompanies(formattedCompanies);
    } catch (err: any) {
      toast.error(err.message);
      setError("Something went wrong.");
    } finally {
      setLoading(false);
    }
  }, []);
  
  
  
  const removeCompany = (companyId: number) => {
    setCompanies((prev) => prev.filter((company) => company.id !== companyId));
  };

  useEffect(() => {
    fetchCompanies();
  }, [fetchCompanies]);

  return (
    <MainLayout>
      <SectionHeader back={true} title="Manage partner company" />
      <ManagePartnerTemplet
        companies={companies}
        loading={loading}
        error={error}
        onRemoveCompany={removeCompany}
      />
    </MainLayout>
  );
};

export default ManagePartnerCompanys;